import * as TypeGraphQL from "type-graphql";
export var InstitutionalFlowSignalScalarFieldEnum;
(function (InstitutionalFlowSignalScalarFieldEnum) {
    InstitutionalFlowSignalScalarFieldEnum["id"] = "id";
    InstitutionalFlowSignalScalarFieldEnum["symbol"] = "symbol";
    InstitutionalFlowSignalScalarFieldEnum["signalDate"] = "signalDate";
    InstitutionalFlowSignalScalarFieldEnum["signalType"] = "signalType";
    InstitutionalFlowSignalScalarFieldEnum["signalStrength"] = "signalStrength";
    InstitutionalFlowSignalScalarFieldEnum["netFlow"] = "netFlow";
    InstitutionalFlowSignalScalarFieldEnum["confidence"] = "confidence";
    InstitutionalFlowSignalScalarFieldEnum["metadata"] = "metadata";
    InstitutionalFlowSignalScalarFieldEnum["createdAt"] = "createdAt";
})(InstitutionalFlowSignalScalarFieldEnum || (InstitutionalFlowSignalScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(InstitutionalFlowSignalScalarFieldEnum, {
    name: "InstitutionalFlowSignalScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=InstitutionalFlowSignalScalarFieldEnum.js.map